import { Box, Typography, IconButton } from "@mui/material";
import { X } from "lucide-mui";
import { useTheme } from "../context/ThemeContext";
import { styledComponent } from "../utils/styled";
import { getFileTypeIcon } from "../utils/fileTypeUtils";

const ChipRoot = styledComponent(Box)(({ isDark }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "4px",
  width: "200px",
  height: "32px",
  paddingLeft: "7px",
  paddingRight: "5px",
  borderRadius: "6px",
  overflow: "hidden",
  border: "1px solid",
  borderColor: isDark ? "#434950" : "#D5D9DF",
  backgroundColor: isDark ? "#31363B" : "#F3F6FA",
  boxShadow: isDark
    ? "0px 4px 4px 0px rgba(0,0,0,0.25)"
    : "0px 4px 4px 0px rgba(0,0,0,0.04)",
}));

const InfoRow = styledComponent(Box)({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  flex: 1,
  minWidth: 0,
});

const iconStyle = { height: "18px", width: "auto", flexShrink: 0 };

const FileName = styledComponent(Typography)(({ isDark }) => ({
  fontSize: "12px",
  fontFamily: "Inter",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.03px",
  color: isDark ? "#ECEFF3" : "#434950",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

const RemoveButton = styledComponent(IconButton)({
  padding: "2px",
  flexShrink: 0,
});

const RemoveIcon = styledComponent(X)(({ isDark }) => ({
  fontSize: 14,
  color: isDark ? "#A8AEB6" : "#6A7079",
}));

export default function AttachedFileChip({
  file_id,
  file_name,
  file_type,
  onRemove,
}) {
  const { isDark } = useTheme();
  const FileIcon = getFileTypeIcon(file_type);

  return (
    <ChipRoot isDark={isDark}>
      <InfoRow>
        {FileIcon && <FileIcon style={iconStyle} />}
        <FileName isDark={isDark}>{file_name}</FileName>
      </InfoRow>
      {onRemove && (
        <RemoveButton size='small' onClick={() => onRemove(file_id)}>
          <RemoveIcon isDark={isDark} />
        </RemoveButton>
      )}
    </ChipRoot>
  );
}
